import { MakeCall } from './createMakeCall';

export interface ListingVideoResource {
  id: number;
  url: string;
  name: string;
  fileSize: number;
  length: number;
  title: string;
  author: string;
}

type Order = number;

export type Videos = ListingVideoResource[];

const changeListingVideoOrder =
  (makeCall: MakeCall) => (listingId: number, order: Order[]) =>
    makeCall<Videos>('PUT', `/api/v2/listing/${listingId}/videos`, {
      data: order,
    });
export { changeListingVideoOrder };
